import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class MenuItem extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        locale: PropTypes.string.isRequired,
        setActiveModule: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.type !== nextProps.type) return true
        if (this.props.active !== nextProps.active) return true

        return false
    }

    onClickHandler = () => {
        const { active, setActiveModule, type } = this.props

        if (!active) setActiveModule(type)
    }

    render() {
        const { active, type, locale } = this.props

        return (
            <div
                className={cx(
                    'menu-item',
                    `type-${type}`,
                    type === 'report' && `icon-new-${locale}`,
                    active && 'active'
                )}
                onClick={this.onClickHandler}
            >
                <FormattedMessage id={`${LOCALE_PREFIX}.${type}`} />
            </div>
        )
    }
}
